import React, { useEffect, useRef, useState } from "react";

import {
  Modal,
  Box,
  Typography,
  Autocomplete,
  Backdrop,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import CloseIcon from "@mui/icons-material/Close";
import { Btn } from "../../AbstractElements";
import { useDispatch, useSelector } from "react-redux";
import {
  getProcessesStatusList,
  getProcessesStatusListByNOA,
} from "../../store/process/actions";

import ConfirmModal from "../CGITrackingNew/ConfirmModal";
import { getUserRole, ShowError } from "../../_helper/helper";
import axios from "axios";
import { useAuth } from "oidc-react";

const DeptAdmin = "Dept Admin";
const Submitted = "Submitted";
const CertOfficer = "Cert Officer";
const AgencyDirector = "Agency Director";
const BBMR = "BBMR";
const AssignAnalyst = "Assign Analyst";
const AnalystReview = "Analyst Review";
const SupervisorReview = "Supervisor Review";
const AdminStaffReview = "Admin Staff Review";
const DirectorReview = "Director Review";
const AdminStaffRouting = "Admin Staff Routing";
const Classification = "Classification";
const Recruitment = "Recruitment";
const EMR = "EMR";
const DrugTesting = "Drug Testing";
const Records = "Records";

const StatusChangeModalBlanket = (props) => {
  const [status, setStatus] = useState("");

  const [approve, setApprove] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [prevStatus, setPrevStatus] = useState({ value: 0, label: "" });
  const [nextStatus, setNextStatus] = useState({ value: 0, label: "" });
  const dispatch = useDispatch();

  const remarkRef = useRef();
  const { processStatusList } = props;

  // const { processStatusList } = useSelector((state) => state.processReducer);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  let returnFromArray = [
    { value: 11, label: "Drug Testing" },
    { value: 10, label: "EMR" },
    { value: 118, label: "Recruitment" },
    { value: 9, label: "Classification" },
    { value: 8, label: "BBMR" },
    { value: 133, label: "Agency Director" },
    { value: 7, label: "Cert Officer" },
    { value: 18, label: "Dept Admin" },
  ];
  let forwardArray = [
    { value: 133, label: "Agency Director" },
    { value: 8, label: "BBMR" },
    { value: 9, label: "Classification" },
    { value: 118, label: "Recruitment" },
    { value: 10, label: "EMR" },
    { value: 11, label: "Drug Testing" },
    { value: 19, label: "Records" },
    { value: 356, label: "Submitted For Final Post" },
    { value: 134, label: "Final Post NPA" },
    { value: 135, label: "Payroll Staging" },
  ];
  const [returnState, setReturnState] = useState(returnFromArray[0]);
  const [forwardState, setForwardState] = useState(forwardArray[0]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredReturnArray, setFilteredReturnArray] =
    useState(returnFromArray);
  const [filteredForwardArray, setFilteredForwardArray] =
    useState(forwardArray);
  const [currentProcessItem, setCurrentProcessItem] = useState();
  // const recordsSeq = processStatusList?.filter((item)=> item?.id == 19)?.seq;
  const [lastSeq, setLastSeq] = useState(12);
  // const [filteredProcessList, setFilteredProcessList] = useState();
  // useEffect(() => {
  //   // dispatch(getProcessesStatusList(1));
  //   console.log("121212 ProcessStatus Modal called:::: ",props?.currentStatus?.value, props?.noa)
  //   debugger
  //   if(props?.noa == "30"){
  //     let filteredArray = dispatch(getProcessesStatusListByNOA({id:1,noa:30}));
  //     setTimeout(()=>{
  //       setFilteredProcessList(filteredArray);
  //     },1000)
  //   }
  // }, [props?.currentStatus?.value]);

  const DepartmentsToSkipBBMR = [
    "GUAM LEGISLATURE",
    // "Public Defender Services Corporation", // we have PUBLIC DEFENDER, PUBLIC DEFENDER CORPORATION OF GUAM
    "JUDICIARY OF GUAM", //"Unified Judiciary of Guam" instead we have JUDICIARY OF GUAM
    "MAYOR'S COUNCIL",
    "OFFICE OF PUBLIC ACCOUNTABILITY",
    "OFFICE OF THE ATTORNEY GENERAL",
    "GUAM MEMORIAL HOSPITAL AUTHORITY",
    "GUAM VISITOR'S BUREAU",
    // "University of Guam", // We don't have in list
    "GUAM COMMUNITY COLLEGE",
    "GUAM ELECTION COMMISSION",
    "GUAM ANCESTRAL LANDS COMMISSION",
    "CHAMORRO LAND TRUST COMMISSION",
    "GUAM COMM. FOR EDUCATOR CERTIFICATION",
    "GSWA - GUAM SOLID WASTE AUTHORITY",
    "GWSA - GUAM SOLID WASTE AUTHORITY",
    "GUAM ETHICS COMMISSION",
  ];

  useEffect(() => {
    let recordsSeq;
    let classificationSeq;
    let newProcessList;
    let BBMRStatuses = [8, 339, 272, 342, 338];
    if (
      processStatusList?.find((item) => item.statusName == "Office of Governor")
    ) {
      if (
        (props?.toGrade && props?.toGrade?.trim()?.substring(0, 2) == "E-") ||
        (props?.fromGrade && props?.fromGrade?.trim()?.substring(0, 2) == "E-")
      ) {
        // newProcessList = processStatusList?.filter((item)=>item.id != 133)
        newProcessList = processStatusList?.filter(
          (item) => item.statusName != "Agency Director"
        );
      } else {
        newProcessList = processStatusList?.filter(
          (item) => item.statusName != "Office of Governor"
        );
        // newProcessList = processStatusList?.filter((item)=>item.id != 301)
      }
    } else {
      // newProcessList = processStatusList;
      newProcessList = processStatusList?.filter(
        (item) => item.statusName != "Drug Testing"
      );
    }
    console.log("123123 ::: ", newProcessList, processStatusList);
    // if(processStatusList && processStatusList.length){
    //   recordsSeq = processStatusList.find((item) => item?.id == 19)?.seq;
    //   setLastSeq(recordsSeq);
    // }
    // console.log("121212 ProcessStatus List  Modal :::: ",processStatusList)
    // if (processStatusList && processStatusList.length && props?.noa != "30" && props?.noa != "58") {
    //   let currentProcess = processStatusList.find(
    //     (item) => item?.id == props?.currentStatus?.value
    //   );
    //   setCurrentProcessItem(currentProcess);
    //   let prevStat;
    //   if (currentProcess?.seq == 3) {
    //     prevStat = processStatusList.find(
    //       (item) => item?.seq == currentProcess?.seq - 2
    //     );
    //   } else {
    //     prevStat = processStatusList.find(
    //       (item) => item?.seq == currentProcess?.seq - 1
    //     );
    //   }
    //   setPrevStatus({ value: prevStat?.id, label: prevStat?.statusName });
    //   let nxtStat = processStatusList.find(
    //     (item) => item?.seq == currentProcess?.seq + 1
    //   );
    //   if (nxtStat) {
    //     setNextStatus({ value: nxtStat?.id, label: nxtStat?.statusName });
    //   }

    //   if (currentProcess?.seq >= 7) {
    //     // && currentProcess?.seq <= 10

    //     if (props?.isGG1Transaction && currentProcess?.seq <= recordsSeq) {
    //       props?.setOptionalMessages([]);
    //       const returnItems = processStatusList
    //         .filter((d) => d.seq != 2 && d.seq != 3 && d.seq != 4 && d.seq != 5 && d.seq != 6 && d.seq < currentProcess?.seq)
    //         .map((d) => {
    //           return { value: d.id, label: d.statusName };
    //         })
    //         .reverse();
    //       setReturnState(returnItems[0]);
    //       setFilteredReturnArray(returnItems);
    //     } else {
    //       const returnItems = processStatusList
    //         .filter(
    //           (d) =>
    //             d.seq > currentProcess?.seq - 2 && d.seq < currentProcess?.seq
    //         )
    //         .map((d) => {
    //           return { value: d.id, label: d.statusName };
    //         });
    //       setReturnState(returnItems[0]);
    //       setFilteredReturnArray(returnItems);
    //       // const forwardItems= processStatusList.filter(d=>  d.seq > currentProcess?.seq).map(d=>{
    //       //   return {value: d.id,label: d.statusName}
    //       // });
    //       // setForwardState(forwardItems[0]);
    //       // setFilteredForwardArray(forwardItems);
    //     }
    //     // let returnStat = processStatusList.find(
    //     //   (item) => item?.seq == currentProcess?.seq - 1
    //     // );
    //     // let fromIndex = returnFromArray.findIndex(
    //     //   (i) => i.value == returnStat.id
    //     // );
    //     // let filteredArray = returnFromArray.slice(
    //     //   fromIndex,
    //     //   returnFromArray.length
    //     // );
    //     // setReturnState(filteredArray[0]);
    //     // setFilteredReturnArray(filteredArray);
    //   }
    //   else if((props?.role == "CERIFYING-OFFICER" || props?.role == "DOA-DIRECTOR" || props?.role == "BBMR-ANALYST" || props?.role == "BBMR-DIRECTOR" || props?.role == "AGENCY-DIRECTOR"))
    //   {
    //     if (props?.isGG1Transaction && currentProcess?.seq < 7) {
    //       props?.setOptionalMessages([]);
    //       const returnItems = processStatusList
    //         .filter((d) => d.seq != 2 && d.seq < currentProcess?.seq)
    //         .map((d) => {
    //           return { value: d.id, label: d.statusName };
    //         })
    //         .reverse();
    //       setReturnState(returnItems[0]);
    //       setFilteredReturnArray(returnItems);
    //     }
    //   }

    //   if (currentProcess?.seq >= 3) {
    //     if (props?.isGG1Transaction && currentProcess?.seq <= recordsSeq) {
    //       let newLastSeq = lastSeq;
    //       if(props?.role == "CERTIFYING-OFFICER"){
    //         newLastSeq = 4;
    //         setLastSeq(4);
    //       }
    //       else if(props?.role == "AGENCY-DIRECTOR"){
    //         newLastSeq = 5;
    //         setLastSeq(5);
    //       }
    //       else if(props?.role == "BBMR-ANALYST"){
    //         newLastSeq = 6;
    //         setLastSeq(6);
    //       }
    //       else if(props?.role == "BBMR-DIRECTOR" || props?.role == "DOA-DIRECTOR"){
    //         newLastSeq = 7;
    //         setLastSeq(7);
    //       }
    //       else{
    //         newLastSeq = recordsSeq;
    //         setLastSeq(recordsSeq);
    //       }

    //       const forwardItems = processStatusList
    //         .filter((d) => d.seq > currentProcess?.seq && d.seq <= newLastSeq)
    //         .map((d) => {
    //           return { value: d.id, label: d.statusName };
    //         });
    //       let newArray = [...forwardItems];
    //       if(props?.toGrade && props?.toGrade?.trim()?.substring(0,2) != "E-"){
    //         newArray = forwardItems.filter((item) => item?.value != 301)
    //       }else{
    //         newArray = forwardItems.filter((item) => item?.value != 133)
    //       }
    //       console.log("123123 ::: ",forwardItems,newArray)
    //       // setForwardState(forwardItems[0]);
    //       // setFilteredForwardArray(forwardItems);
    //       setForwardState(newArray[0]);
    //       setFilteredForwardArray(newArray);
    //     } else {
    //       const forwardItems = processStatusList
    //         .filter((d) => d.seq > currentProcess?.seq)
    //         .map((d) => {
    //           return { value: d.id, label: d.statusName };
    //         });
    //       setForwardState(forwardItems[0]);
    //       setFilteredForwardArray(forwardItems);
    //     }
    //   }
    // }
    // else{
    //   if(processStatusList && processStatusList.length){
    //     let FilteredStatusList = processStatusList?.filter((item)=>item?.id == 18 || item?.id == 10 || item?.id == 19)
    //     if(props?.noa == "30"){
    //       if(props?.evaluation?.value == "S" && props?.currentStatus?.value == 18){
    //         FilteredStatusList = processStatusList?.filter((item)=>item?.id == 18 || item?.id == 19)
    //       }
    //     }
    //     console.log("123123 ::: ",FilteredStatusList,props?.evaluation)
    //     let currentProcess = FilteredStatusList.find(
    //       (item) => item?.id == props?.currentStatus?.value
    //     );
    //     setCurrentProcessItem(currentProcess);
    //     let prevStat;
    //     let currentIndex = FilteredStatusList.findIndex((item) => item?.seq == currentProcess?.seq);
    //     if (currentProcess?.seq > 1) {
    //       prevStat = FilteredStatusList[currentIndex - 1];
    //     }
    //     setPrevStatus({ value: prevStat?.id, label: prevStat?.statusName });
    //     setReturnState({ value: prevStat?.id, label: prevStat?.statusName });
    //     if(currentIndex < FilteredStatusList?.length){
    //       let nxtStat = FilteredStatusList[currentIndex + 1]
    //       if (nxtStat) {
    //         setNextStatus({ value: nxtStat?.id, label: nxtStat?.statusName });
    //         setForwardState({ value: nxtStat?.id, label: nxtStat?.statusName });
    //       }
    //     }

    //     if (currentProcess?.id == 19) {
    //       props?.setOptionalMessages([]);
    //       const returnItems = FilteredStatusList
    //         .filter((d) => d.id != 19)
    //         .map((d) => {
    //           return { value: d.id, label: d.statusName };
    //         })
    //         .reverse();
    //       setReturnState(returnItems[0]);
    //       setFilteredReturnArray(returnItems);
    //     }
    //   }
    // }



    if (newProcessList && newProcessList.length) {
      recordsSeq = newProcessList.find(
        (item) => item?.statusName == "Payroll Staging"
      )?.seq;
      setLastSeq(recordsSeq);
      classificationSeq = newProcessList.find(
        (item) => item?.statusName == "Classification"
      )?.seq;
      newProcessList = newProcessList.filter(
        (item) =>
          item?.statusName != "Admin Staff Review" &&
          item?.statusName != "Admin Staff Routing" &&
          item?.statusName !== "Named GG1"
      );
      if (
        DepartmentsToSkipBBMR.includes(props?.toDepartment) ||
        props?.BBMRSkipLogin
      ) {
        newProcessList = processStatusList.filter(
          (item) =>
            item.seq <= recordsSeq &&
            !item?.parentId &&
            !BBMRStatuses.includes(item.id)
        );
      }
    }
    console.log("121212 ProcessStatus List  Modal :::: ", newProcessList);
    if (
      newProcessList &&
      newProcessList.length &&
      props?.noa != "30" &&
      props?.noa != "58"
    ) {
      let currentProcess = newProcessList.find(
        (item) => item?.id == props?.currentStatus?.value
      );
      setCurrentProcessItem(currentProcess);
      let prevStat;
      // if (currentProcess?.seq == 3) {
      if (currentProcess?.id == 7 || currentProcess?.id == 342) {
        prevStat = newProcessList.find(
          (item) => item?.seq == currentProcess?.seq - 2
        );
      } else {
        if (
          newProcessList?.find(
            (item) => item?.statusName == "Office of Governor"
          )
        ) {
          if (currentProcess?.id == 272) {
            if (
              (props?.toGrade &&
                props?.toGrade?.trim()?.substring(0, 2) == "E-") ||
              (props?.fromGrade &&
                props?.fromGrade?.trim()?.substring(0, 2) == "E-")
            ) {
              prevStat = newProcessList.find(
                (item) => item?.seq == currentProcess?.seq - 1
              );
            } else {
              prevStat = newProcessList.find(
                (item) => item?.seq == currentProcess?.seq - 2
              );
            }
          } else if (
            currentProcess?.id == 301 ||
            currentProcess?.statusName == "Office of Governor"
          ) {
            prevStat = newProcessList.find(
              (item) => item?.seq == currentProcess?.seq - 2
            );
          } else {
            prevStat = newProcessList.find(
              (item) => item?.seq == currentProcess?.seq - 1
            );
          }
        } else {
          prevStat = newProcessList.find(
            (item) => item?.seq == currentProcess?.seq - 1
          );
        }
      }
      if (prevStat) {
        setPrevStatus({ value: prevStat?.id, label: prevStat?.statusName });
      } else {
        if (
          newProcessList[
          newProcessList.findIndex((i) => i?.id == currentProcess?.id) - 1
          ]
        ) {
          let prevState =
            newProcessList[
            newProcessList.findIndex((i) => i?.id == currentProcess?.id) - 1
            ];
          setPrevStatus({ value: prevState?.id, label: prevState?.statusName });
        }
      }
      let nxtStat = newProcessList.find(
        (item) => item?.seq == currentProcess?.seq + 1
      );
      if (nxtStat) {
        setNextStatus({ value: nxtStat?.id, label: nxtStat?.statusName });
      } else {
        if (
          newProcessList[
          newProcessList.findIndex((i) => i?.id == currentProcess?.id) + 1
          ]
        ) {
          let nextState =
            newProcessList[
            newProcessList.findIndex((i) => i?.id == currentProcess?.id) + 1
            ];
          setNextStatus({ value: nextState?.id, label: nextState?.statusName });
        }
      }
      if (currentProcess?.seq >= classificationSeq) {
        // && currentProcess?.seq <= 10

        if (props?.isGG1Transaction && currentProcess?.seq <= recordsSeq) {
          props?.setOptionalMessages([]);
          const returnItems = newProcessList
            // .filter((d) => d.seq != 2 && d.seq != 3 && d.seq != 4 && d.seq != 5 && d.seq != 6 && d.seq < currentProcess?.seq && !d.parentId)
            .filter(
              (d) =>
                d.seq != 2 &&
                d.seq != 3 &&
                d.seq != 4 &&
                d.seq < currentProcess?.seq &&
                !d.parentId
            )
            .map((d) => {
              return { value: d.id, label: d.statusName };
            })
            .reverse();
          setReturnState(returnItems[0]);
          setFilteredReturnArray(returnItems);
        } else {
          const returnItems = newProcessList
            .filter(
              (d) =>
                d.seq > currentProcess?.seq - 2 && d.seq < currentProcess?.seq
            )
            .map((d) => {
              return { value: d.id, label: d.statusName };
            });
          setReturnState(returnItems[0]);
          setFilteredReturnArray(returnItems);
          // const forwardItems= newProcessList.filter(d=>  d.seq > currentProcess?.seq).map(d=>{
          //   return {value: d.id,label: d.statusName}
          // });
          // setForwardState(forwardItems[0]);
          // setFilteredForwardArray(forwardItems);
        }
        // let returnStat = newProcessList.find(
        //   (item) => item?.seq == currentProcess?.seq - 1
        // );
        // let fromIndex = returnFromArray.findIndex(
        //   (i) => i.value == returnStat.id
        // );
        // let filteredArray = returnFromArray.slice(
        //   fromIndex,
        //   returnFromArray.length
        // );
        // setReturnState(filteredArray[0]);
        // setFilteredReturnArray(filteredArray);
      }
      // else if((props?.role == "CERTIFYING-OFFICER" || props?.role == "DOA-DIRECTOR" || props?.role == "BBMR-ANALYST" || props?.role == "BBMR-DIRECTOR" || props?.role == "AGENCY-DIRECTOR"))
      else if (
        props?.role == "DEPT-ADMIN" ||
        props?.role == "CERTIFYING-OFFICER" ||
        props?.role == "DOA-DIRECTOR" ||
        props?.role == "BBMR-ANALYST" ||
        props?.role == "BBMR-ADMIN" ||
        props?.role == "BBMR-SUPERVISOR" ||
        props?.role == "BBMR-DIRECTOR" ||
        props?.role == "AGENCY-DIRECTOR"
      ) {
        // if (props?.isGG1Transaction && currentProcess?.seq < 7) {
        if (
          props?.isGG1Transaction &&
          currentProcess?.seq < classificationSeq
        ) {
          props?.setOptionalMessages([]);
          if (
            currentProcess?.id == 272 ||
            currentProcess?.id == 339 ||
            currentProcess?.id == 343
          ) {
            const returnItems = newProcessList
              .filter(
                (d) =>
                  d.seq != 2 &&
                  d.seq < currentProcess?.seq &&
                  !d.parentId &&
                  d.id != 338
              )
              .map((d) => {
                return { value: d.id, label: d.statusName };
              })
              .reverse();
            setReturnState(returnItems[0]);
            setFilteredReturnArray(returnItems);
          } else if (
            currentProcess?.id == 8 ||
            currentProcess?.id == 340 ||
            currentProcess?.id == 342
          ) {
            if (currentProcess?.id == 342) {
              const returnItems = newProcessList
                // .filter((d) => d.seq != 2 && d.seq < currentProcess?.seq && d.id == 133)
                .filter(
                  (d) =>
                    d.seq != 2 &&
                    d.seq < currentProcess?.seq &&
                    d.id >= 133 &&
                    d.id != 338
                )
                .map((d) => {
                  return { value: d.id, label: d.statusName };
                })
                .reverse();
              setReturnState(returnItems[0]);
              setFilteredReturnArray(returnItems);
            } else if (currentProcess?.id == 8) {
              const returnItems = newProcessList
                // .filter((d) => d.seq != 2 && d.seq < currentProcess?.seq && d.seq >= currentProcess?.seq - 2)
                .filter(
                  (d) =>
                    d.seq != 2 && d.seq < currentProcess?.seq && d.id != 338
                )
                .map((d) => {
                  return { value: d.id, label: d.statusName };
                })
                .reverse();
              setReturnState(returnItems[0]);
              setFilteredReturnArray(returnItems);
            } else {
              const returnItems = newProcessList
                .filter(
                  (d) =>
                    d.seq != 2 &&
                    d.seq < currentProcess?.seq &&
                    d.seq >= currentProcess?.seq - 1
                )
                .map((d) => {
                  return { value: d.id, label: d.statusName };
                })
                .reverse();
              setReturnState(returnItems[0]);
              setFilteredReturnArray(returnItems);
            }
          } else {
            const returnItems = newProcessList
              .filter((d) => d.seq != 2 && d.seq < currentProcess?.seq)
              .map((d) => {
                return { value: d.id, label: d.statusName };
              })
              .reverse();
            setReturnState(returnItems[0]);
            setFilteredReturnArray(returnItems);
          }
        }
      } else {
        const returnItems = newProcessList
          .filter(
            (d) => d.seq != 2 && d.seq < currentProcess?.seq && d.id != 338
          )
          .map((d) => {
            return { value: d.id, label: d.statusName };
          })
          .reverse();
        setReturnState(returnItems[0]);
        setFilteredReturnArray(returnItems);
      }

      if (
        currentProcess?.id == 272 ||
        currentProcess?.id == 339 ||
        currentProcess?.id == 343
      ) {
        const returnItems = newProcessList
          .filter(
            (d) => d.seq != 2 && d.seq < currentProcess?.seq && d.id != 338
          )
          .map((d) => {
            return { value: d.id, label: d.statusName };
          })
          .reverse();
        console.log("123123 returnItems ::: ", returnItems);
        setReturnState(returnItems[0]);
        setFilteredReturnArray(returnItems);
      }

      if (
        currentProcess?.seq >= 3 ||
        (props?.maxStatus != 0 &&
          props?.maxStatus > 4 &&
          currentProcess?.seq >= 1)
      ) {
        if (props?.isGG1Transaction && currentProcess?.seq <= recordsSeq) {
          let newLastSeq = lastSeq;
          let maxSeq = 0;
          if (props?.maxStatus && props?.maxStatus > currentProcess?.seq + 1) {
            maxSeq = newProcessList.find(
              (item) => item?.seq == props?.maxStatus
            )?.seq;
          }

          if (!newProcessList.find((item) => item?.seq == maxSeq) || maxSeq == "undefined") {
            maxSeq = 0;
          }

          if (props?.role == "DEPT-ADMIN") {
            if (maxSeq != 0) {
              newLastSeq = maxSeq;
              setLastSeq(maxSeq);
            } else {
              newLastSeq = 3;
              setLastSeq(3);
            }
          } else if (props?.role == "CERTIFYING-OFFICER") {
            if (maxSeq != 0) {
              newLastSeq = maxSeq;
              setLastSeq(maxSeq);
            } else {
              newLastSeq = 4;
              setLastSeq(4);
            }
          } else if (props?.role == "AGENCY-DIRECTOR") {
            if (maxSeq != 0) {
              newLastSeq = maxSeq;
              setLastSeq(maxSeq);
            } else {
              // newLastSeq = 7;
              // setLastSeq(7);
              if (
                DepartmentsToSkipBBMR.includes(props?.toDepartment) ||
                props?.BBMRSkipLogin
              ) {
                let currIndex = processStatusList.findIndex(
                  (item) => item.id == 133
                );
                let nextSeq = newProcessList[currIndex + 1]?.seq;
                newLastSeq = nextSeq;
                setLastSeq(nextSeq);
              } else {
                newLastSeq = 5;
                setLastSeq(5);
              }
            }
          }
          // else if(props?.role == "BBMR-ADMIN"){
          //   newLastSeq = 12;
          //   setLastSeq(12);
          // }
          // else if(props?.role == "BBMR-ANALYST"){
          //   newLastSeq = 8;
          //   setLastSeq(8);
          // }
          else if (props?.role == "BBMR-SUPERVISOR") {
            newLastSeq = 10;
            setLastSeq(10);
          } else if (
            props?.role == "BBMR-DIRECTOR" ||
            props?.role == "DOA-DIRECTOR"
          ) {
            // if(props?.role == "BBMR-DIRECTOR"){
            //   newLastSeq = 11;
            //   setLastSeq(11);
            // }else{
            newLastSeq = 12;
            setLastSeq(12);
            // }
          } else if (props?.role == "SUPER-USER") {
            newLastSeq = recordsSeq;
            setLastSeq(recordsSeq);
          } else {
            newLastSeq = currentProcess?.seq + 1;
            setLastSeq(currentProcess?.seq + 1);
          }

          let forwardItems = newProcessList
            .filter((d) => d.seq > currentProcess?.seq && d.seq <= newLastSeq)
            .map((d) => {
              return { value: d.id, label: d.statusName };
            });
          if (currentProcess?.seq == 1) {
            forwardItems = newProcessList
              .filter(
                (d) =>
                  d.seq > currentProcess?.seq &&
                  d.seq <= newLastSeq &&
                  d.id != 6
              )
              .map((d) => {
                return { value: d.id, label: d.statusName };
              });
          }
          let newArray = [...forwardItems];
          if (
            newProcessList?.find(
              (item) => item?.statusName == "Office of Governor"
            )
          ) {
            if (
              (props?.toGrade &&
                props?.toGrade?.trim()?.substring(0, 2) == "E-") ||
              (props?.fromGrade &&
                props?.fromGrade?.trim()?.substring(0, 2) == "E-")
            ) {
              newArray = forwardItems.filter(
                (item) => item?.label != "Agency Director"
              );
              // newArray = forwardItems.filter((item) => item?.value != 133)
            } else {
              newArray = forwardItems.filter(
                (item) => item?.label != "Office of Governor"
              );
              // newArray = forwardItems.filter((item) => item?.value != 301)
            }
          }
          console.log("123123 ::: ", forwardItems, newArray);
          // setForwardState(forwardItems[0]);
          // setFilteredForwardArray(forwardItems);
          setForwardState(newArray[0]);
          setFilteredForwardArray(newArray);
        } else {
          const forwardItems = newProcessList
            .filter((d) => d.seq > currentProcess?.seq)
            .map((d) => {
              return { value: d.id, label: d.statusName };
            });
          setForwardState(forwardItems[0]);
          setFilteredForwardArray(forwardItems);
        }
      }
    } else {
      if (newProcessList && newProcessList.length) {
        let FilteredStatusList = newProcessList?.filter(
          (item) => item?.id == 18 || item?.id == 10 || item?.id == 19
        );
        if (props?.noa == "30") {
          if (
            props?.evaluation?.value == "S" &&
            props?.currentStatus?.value == 18
          ) {
            FilteredStatusList = newProcessList?.filter(
              (item) => item?.id == 18 || item?.id == 19
            );
          }
        }
        console.log("123123 ::: ", FilteredStatusList, props?.evaluation);
        let currentProcess = FilteredStatusList.find(
          (item) => item?.id == props?.currentStatus?.value
        );
        setCurrentProcessItem(currentProcess);
        let prevStat;
        let currentIndex = FilteredStatusList.findIndex(
          (item) => item?.seq == currentProcess?.seq
        );
        if (currentProcess?.seq > 1) {
          prevStat = FilteredStatusList[currentIndex - 1];
        }
        setPrevStatus({ value: prevStat?.id, label: prevStat?.statusName });
        setReturnState({ value: prevStat?.id, label: prevStat?.statusName });
        if (currentIndex < FilteredStatusList?.length) {
          let nxtStat = FilteredStatusList[currentIndex + 1];
          if (nxtStat) {
            setNextStatus({ value: nxtStat?.id, label: nxtStat?.statusName });
            setForwardState({ value: nxtStat?.id, label: nxtStat?.statusName });
          }
        }

        // if (currentProcess?.id == 19) {
        //   props?.setOptionalMessages([]);
        //   const returnItems = FilteredStatusList.filter((d) => d.id != 19)
        //     .map((d) => {
        //       return { value: d.id, label: d.statusName };
        //     })
        //     .reverse();
        //   setReturnState(returnItems[0]);
        //   setFilteredReturnArray(returnItems);
        // }
        if (currentProcess?.id == 135) {
          props?.setOptionalMessages([]);
          const returnItems = FilteredStatusList.filter((d) => d.id != 135)
            .map((d) => {
              return { value: d.id, label: d.statusName };
            })
            .reverse();
          setReturnState(returnItems[0]);
          setFilteredReturnArray(returnItems);
        }
      }
    }
  }, [processStatusList, props?.evaluation, props?.toGrade, props?.fromGrade]);

  /****** */
  const { userData } = useAuth();
  const [isUnAssignedApplicants, setIsUnAssignedApplicants] = useState(false);
  const [totalUnAssigned, setTotalUnAssigned] = useState(0);

  const CheckAssignedJobOrder = async (Id) => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    const payload = {
      tableName: "Blanket_gg1",
      SearchParams: `[]`,
      columns: "Job_Order_Number",
      pageNumber: 1,
      pageSize: 1,
      orderBy: "Id ASC",
      sortBy: "",
      orderByMultiple: "",
      limit: 1,
      sortData: "",
      additionalWhere: `parentId=${Id} AND Job_Order_Number is null`,
    };
    await axios.post(`${newBaseURL}/AdvanceSearch/global`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
        Role: getUserRole(userData),
      },
    })
      .then((response) => {
        // let finalResponse = response.data.results;
        console.log("123123 finalResponsexxx", response.data)
        if (response.data.results.length) {
          setIsUnAssignedApplicants(true);
          setTotalUnAssigned(response.data.rowCount)
        }

      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
      });
  };
  useEffect(() => {
    if (props?.batchId) {
      CheckAssignedJobOrder(props?.batchId)
    }
  }, [props?.batchId])


  /******* */

  const handleSubmit = () => {
    if (
      props?.currentStatus?.value == 342 &&
      !CheckValue(props?.bbmrAnalyst) &&
      approve
    ) {
      ShowError("Please Assign Any BBMR Analyst");
      return false;
    }

    if (props?.maxHours == null || props?.maxHours == 0 || props?.maxHours == "") {
      ShowError("Max Authorized Hours cannot be blank or 0.")
      return false
    }

    if (approve && (forwardState?.value == 134 || forwardState?.value == 135) && isUnAssignedApplicants && props?.noa != 95 && props?.noa != "95") {
      // if(props?.batchId){
      //   CheckAssignedJobOrder(props?.batchId)
      // }
      // CheckAssignedJobOrder(props?.batchId)
      ShowError(`There are ${totalUnAssigned} Applicant(s)  with no Job Order assigned.  NPA Final Post requires that all Applicants have a Job Order assigned.`);
      props.handleClose();
      return false;
    }
    if (approve && forwardState?.value == 135 && props?.currentStatus?.value != 134) {
      console.log("123123 delete :::", forwardState, props?.currentStatus)
      ShowError("Please forward to Final Post NPA first then after only payroll staging can be done")
      props.handleClose();
      return false;
    }
    setOpenConfirmation(true);
  };

  const CheckValue = (temp) => {
    if (temp !== null && temp !== undefined && temp !== "") {
      return true;
    }
    return false;
  };

  const onConfirm = () => {
    // console.log("121212 props::: ",forwardState, returnState, props)
    if (approve) {
      // props.setFieldValue("CurrentProcessStatus", nextStatus);
      if (props?.errorMsgs?.length == 0) {
        props?.setLocalCurrentStatus(props?.currentStatus);
        if (props?.noa == "30" || props?.noa == "58") {
          if (props?.uploadedDocuments?.length > 0) {
            props.setFieldValue("CurrentProcessStatus", forwardState);
          }
        } else {
          console.log("123123 statusmodal ", forwardState)
          props.setFieldValue("CurrentProcessStatus", forwardState);
        }
      }
      props.setStatusRemark(remarks);
      props.setProcessStatusChanged(true);
      props.handleClose();
    } else {
      if (remarks != "") {
        if (prevStatus.value != 0) {
          props?.setLocalCurrentStatus(props?.currentStatus);
          if (
            props?.currentStatus?.value == 9 ||
            props?.currentStatus?.value == 118 ||
            props?.currentStatus?.value == 10 ||
            props?.currentStatus?.value == 11 ||
            props?.currentStatus?.value == 8 ||
            props?.currentStatus?.value == 272 ||
            props?.currentStatus?.value == 339 ||
            props?.currentStatus?.value == 342 ||
            props?.currentStatus?.value == 19 ||
            props?.currentStatus?.value == 356
            // ||
            // props?.currentStatus?.value == 134 ||
            // props?.currentStatus?.value == 135
          ) {
            if (props?.errorMsgs?.length == 0) {
              console.log("123123 statusmodal ret ", returnState)
              props.setFieldValue("CurrentProcessStatus", returnState);
            }
          } else {
            console.log("123123 statusmodal ret ", returnState, props?.toDivision, props?.errorMsgs)
            if (props?.errorMsgs?.length == 0) {
              props.setFieldValue("CurrentProcessStatus", prevStatus);
            }
          }
        }
        props.setStatusRemark(remarks);
        props.setProcessStatusChanged(true);
        props.handleClose();
      }
    }
  };

  return (
    <div>
      <Dialog open={props.isOpen} onClose={props.handleClose} fullWidth>
        <DialogTitle>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            Current Status: {props?.currentStatus?.label}
            <IconButton onClick={props.handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
          {/* <Typography>
            <h5>
              Status Changed to:{" "}
              <b>{props?.newProcessStatus?.label || nextStatus?.label}</b>
            </h5>
          </Typography> */}
        </DialogTitle>
        <DialogContent>
          {/* {console.log("112112 ::: ",currentProcessItem, lastSeq)} */}
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              {/* {(props?.currentStatus?.value == 19 && props?.isGG1Transaction) ||
              props?.currentStatus?.value != 135 ? null : ( */}
              {(props?.currentStatus?.value == 135 && props?.isGG1Transaction) ||
                currentProcessItem?.seq == lastSeq ? null : (
                <FormControlLabel
                  value="Approve"
                  control={
                    <Radio
                      onChange={(e, v) => {
                        setStatus(e.target.value);
                        setApprove(true);
                        props.setStatusAction("Approved");
                        if (props?.noa != "30" && props?.noa != "58") {
                          setFilteredForwardArray(filteredForwardArray);
                          setShowDropdown(true);
                        }
                      }}
                      checked={
                        status && status.trim() == "Approve" ? true : false
                      }
                    />
                  }
                  // label={`Forward to ${nextStatus?.label}`} //"Approve"
                  label={`Forward to ${forwardState?.label}`} //"Approve"
                />
              )}
              {props?.currentStatus?.value != 18 && props?.currentStatus?.value != 134 && props?.currentStatus?.value != 135 ? (
                <FormControlLabel
                  value="Return"
                  control={
                    <Radio
                      onChange={(e, v) => {
                        setStatus(e.target.value);
                        setApprove(false);
                        if (
                          props?.currentStatus?.value == 9 ||
                          props?.currentStatus?.value == 118 ||
                          props?.currentStatus?.value == 10 ||
                          props?.currentStatus?.value == 8 ||
                          props?.currentStatus?.value == 272 ||
                          props?.currentStatus?.value == 339 ||
                          props?.currentStatus?.value == 342 ||
                          props?.currentStatus?.value == 11 ||
                          props?.currentStatus?.value == 19 ||
                          props?.currentStatus?.value == 356
                          // ||
                          // props?.currentStatus?.value == 134 ||
                          // props?.currentStatus?.value == 135
                        ) {
                          if (
                            (props?.noa == 30 &&
                              props?.currentStatus?.value == 10) ||
                            (props?.noa == "58" &&
                              props?.currentStatus?.value == 10)
                          ) {
                            setShowDropdown(false);
                          } else {
                            setShowDropdown(true);
                          }
                          props.setStatusAction(
                            `Return to ${returnState?.label}`
                          );
                        } else {
                          if (
                            props?.role == "CERIFYING-OFFICER" ||
                            props?.role == "DOA-DIRECTOR" ||
                            props?.role == "BBMR-ANALYST" ||
                            props?.role == "BBMR-ADMIN" ||
                            props?.role == "BBMR-SUPERVISOR" ||
                            props?.role == "BBMR-DIRECTOR" ||
                            props?.role == "AGENCY-DIRECTOR"
                          ) {
                            setShowDropdown(true);
                            props.setStatusAction(
                              `Return to ${returnState?.label}`
                            );
                          }
                          props.setStatusAction(
                            `Return to ${prevStatus?.label}`
                          );
                        }
                      }}
                      checked={
                        status && status.trim() == "Return" ? true : false
                      }
                      ref={remarkRef}
                    />
                  }
                  label={
                    props?.currentStatus?.value == 9 ||
                      props?.currentStatus?.value == 118 ||
                      props?.currentStatus?.value == 10 ||
                      props?.currentStatus?.value == 8 ||
                      props?.currentStatus?.value == 272 ||
                      props?.currentStatus?.value == 339 ||
                      props?.currentStatus?.value == 342 ||
                      props?.currentStatus?.value == 11 ||
                      props?.currentStatus?.value == 19 ||
                      props?.currentStatus?.value == 356
                      // ||
                      // props?.currentStatus?.value == 134 ||
                      // props?.currentStatus?.value == 135
                      ? `Return to ${returnState?.label}`
                      : props?.role == "CERIFYING-OFFICER" ||
                        props?.role == "DOA-DIRECTOR" ||
                        props?.role == "BBMR-ANALYST" ||
                        props?.role == "BBMR-ADMIN" ||
                        props?.role == "BBMR-SUPERVISOR" ||
                        props?.role == "BBMR-DIRECTOR" ||
                        props?.role == "AGENCY-DIRECTOR"
                        ? `Return to ${returnState?.label}`
                        : `Return to ${prevStatus?.label}`
                  }
                />
              ) : null}
              {/* <FormControlLabel
                value="AdditionalInfo"
                control={
                  <Radio
                    onChange={(e, v) => {
                      setStatus(e.target.value);
                      setApprove(false);
                      props.setStatusAction("Additional Info Required");
                    }}
                    checked={
                      status && status.trim() == "AdditionalInfo" ? true : false
                    }
                  />
                }
                label="Additional Info Required"
              /> */}
            </RadioGroup>
          </FormControl>
          {(props?.currentStatus?.value == 9 ||
            props?.currentStatus?.value == 118 ||
            props?.currentStatus?.value == 8 ||
            props?.currentStatus?.value == 272 ||
            props?.currentStatus?.value == 339 ||
            props?.currentStatus?.value == 342 ||
            props?.currentStatus?.value == 10 ||
            props?.currentStatus?.value == 11 ||
            props?.currentStatus?.value == 19 ||
            props?.currentStatus?.value == 356
            // ||
            // props?.currentStatus?.value == 134 ||
            // props?.currentStatus?.value == 135
          ) &&
            !approve &&
            showDropdown ? (
            <Autocomplete
              size="small"
              name="ReturnStatus"
              InputLabelProps={{
                shrink: true,
              }}
              id="CurrentProcessStatus"
              disableClearable={true}
              value={returnState}
              // options={returnFromArray}
              options={filteredReturnArray}
              getOptionLabel={(option) =>
                option.label ? option.label?.toString() : ""
              }
              onChange={(e, v) => {
                setReturnState(v);
                props.setStatusAction(`Return to ${v?.label}`);
                // console.log("123123 ", v, returnState, props?.currentStatus);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Return To"
                />
              )}
            />
          ) : !approve &&
            showDropdown &&
            (props?.role == "CERIFYING-OFFICER" ||
              props?.role == "DOA-DIRECTOR" ||
              props?.role == "BBMR-ANALYST" ||
              props?.role == "BBMR-ADMIN" ||
              props?.role == "BBMR-SUPERVISOR" ||
              props?.role == "BBMR-DIRECTOR" ||
              props?.role == "AGENCY-DIRECTOR") ? (
            <Autocomplete
              size="small"
              name="ReturnStatus"
              InputLabelProps={{
                shrink: true,
              }}
              id="CurrentProcessStatus"
              disableClearable={true}
              value={returnState}
              // options={returnFromArray}
              options={filteredReturnArray}
              getOptionLabel={(option) =>
                option.label ? option.label?.toString() : ""
              }
              onChange={(e, v) => {
                setReturnState(v);
                props.setStatusAction(`Return to ${v?.label}`);
                // console.log("123123 ", v, returnState, props?.currentStatus);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Return To"
                />
              )}
            />
          ) : approve &&
            showDropdown &&
            props?.noa != "30" &&
            props?.noa != "58" ? (
            <Autocomplete
              size="small"
              name="ReturnStatus"
              InputLabelProps={{
                shrink: true,
              }}
              id="CurrentProcessStatus"
              disableClearable={true}
              value={forwardState}
              // options={returnFromArray}
              options={filteredForwardArray}
              getOptionLabel={(option) =>
                option.label ? option.label?.toString() : ""
              }
              onChange={(e, v) => {
                setForwardState(v);
                // console.log(
                //   "123123 forward",
                //   v,
                //   forwardArray,
                //   props?.currentStatus
                // );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Forward To"
                />
              )}
            />
          ) : null}
          <TextField
            margin="dense"
            variant="outlined"
            style={{ width: "100%" }}
            size="small"
            label="Remarks"
            multiline={true}
            rows={4}
            InputLabelProps={{
              shrink: true,
            }}
            // className="flex w-full mx-10"
            onChange={(e) => {
              setRemarks(e.target.value);
            }}
            error={remarkRef?.current?.childNodes[0].value == status?.trim()}
            className={`flex w-full mx-10 ${remarkRef?.current?.childNodes[0].value == status?.trim()
                ? "hasErrorLbl"
                : ""
              } `}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", marginBottom: "10px" }}>
          <Btn
            attrBtn={{
              color: "primary",
              onClick: () => {
                if (remarks != "" || approve) {
                  handleSubmit();
                }
              }, // props.handleClose
            }}
          >
            Submit
          </Btn>
        </DialogActions>
      </Dialog>
      {openConfirmation && (
        <ConfirmModal
          open={openConfirmation}
          setOpen={setOpenConfirmation}
          confimClick={onConfirm}
          cnfrmBtnName="Yes"
          cancelBtnName="No"
          message={"Are you sure to make this change?"}
        // modalHeader="Alert Message"
        />
      )}
    </div>
  );
};
export default StatusChangeModalBlanket;
